export { default } from "./SpeedDialIcon.mjs";
export { default as speedDialIconClasses } from "./speedDialIconClasses.mjs";
export * from "./speedDialIconClasses.mjs";